import { Grid2 } from "@mui/material";
import AlertCountGraph from "./AlertCountGraph.js";
import ResolutionTimeGraph from "./ResolutionTimeGraph.js";
import AlertTypeGraph from "./AlertTypeGraph.js";
import TimeButtons from "./TimeButtons.js";
import HeaderBar from "../Shared/HeaderBar/HeaderBar.js";
import NavigationBar from "../Shared/NavigationBar/NavigationBar.js"

export default function AnalyticsPage() {
  return (
    <>
      <HeaderBar></HeaderBar>
      <TimeButtons buttons={["30 days", "6 months", "Max"]} />
      <Grid2 container={true} height={'80vh'} justifyContent={'center'} alignItems={'center'} direction={'row'} spacing={4} id={"AnalyticsPageGrid"}>
        <AlertCountGraph sx={{height:200}}/>
        <ResolutionTimeGraph />
        <AlertTypeGraph />
      </Grid2>
      <NavigationBar></NavigationBar>
    </>
  );
}
